(function () {
    const list = document.querySelector('.ps-list');
    if (!list) return;

    // 라벨 토글 처리
    function toggleLabel(label) {
        const panel = label.nextElementSibling;
        if (!panel || !panel.classList.contains('ps-cont')) return;

        const isActive = label.classList.contains('is-active');

        // 모든 라벨 닫기
        list.querySelectorAll('.ps-label.is-active').forEach(activeLabel => {
            activeLabel.classList.remove('is-active');
        });

        // 클릭한 라벨이 닫혀있었으면 열기
        if (!isActive) {
            label.classList.add('is-active');
        }
    }

    // 클릭 이벤트 처리
    list.addEventListener('click', (e) => {
        const label = e.target.closest('.ps-label');
        if (!label) return;

        toggleLabel(label);
    });
})();

(function() {
    const zoom = document.querySelector('.product-detail-zoom');
    const zoomInner = document.querySelector('.product-detail-zoom-inner');
    const zoomItems = Array.from(document.querySelectorAll('.product-zoom'));
    const closeBtn = document.querySelector('.product-detail-zoom-close-btn');

    // 줌 이미지 media-id 매핑
    const zoomImgs = zoomItems.map(el => el.querySelector('img'));
    const idToIndex = new Map(
        zoomImgs.map((img, idx) => [img?.dataset.mediaId, idx])
    );

    // 클릭 트리거 대상
    const triggers = Array.from(document.querySelectorAll('.product-img img'));

    function openZoom() {
        if (!zoom) return;
        zoom.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
    }

    function closeZoom() {
        if (!zoom) return;
        zoom.classList.remove('is-open');
        document.documentElement.style.overflow = '';
    }

    function scrollToIndex(idx) {
        const target = zoomItems[idx];
        if (!target || !zoomInner) return;
        zoomInner.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
    }

    // 썸네일 클릭
    triggers.forEach((el, i) => {
        el.addEventListener('click', (e) => {
            if (e.target.closest('a')) e.preventDefault();

            const mediaId = el.dataset.mediaId;
            let idx = idToIndex.has(mediaId) ? idToIndex.get(mediaId) : i;

            if (idx < 0 || idx >= zoomItems.length) idx = 0;

            openZoom();
            scrollToIndex(idx);
        });
    });

    // 닫기 버튼
    if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            closeZoom();
        });
    }

    // 배경 클릭시 닫기
    zoom?.addEventListener('click', (e) => {
        if (!e.target.closest('.product-detail-zoom-inner') &&
            !e.target.closest('.product-detail-zoom-close-btn')) {
            closeZoom();
        }
    });
})();